import React from 'react';
import CompanyFoldersTable from '@components/pages/admin/folder/CompanyFoldersTable.tsx';

interface ComponentProps {
  companyId: string;
}

/** RD-2977: customer self-service management of folders and their visibility (Company profile → Folders). */
const CompanyProfileFolders: React.FC<ComponentProps> = ({ companyId }) => <CompanyFoldersTable mode={'customer'} companyId={companyId} />;

export default CompanyProfileFolders;
